import { OverflowMenu, OverflowMenuItem } from "@carbon/react";
import { FC } from "react";

import { Scope, ScopeResource } from "src/authentication/PermissionsProvider";
import { usePermissions } from "src/authentication/usePermissions";
import OverlayLoading from "src/components/DataStates/OverlayLoading";
import { useToast } from "src/components/Toasts/ToastContainer";
import { useCreateActionMutation } from "src/graphql/anti-fraud/queries/customers/mutations/CreateActionMutation";
import { useT } from "src/internationalization";

export type TopLabel = {
  label: string;
  value: string;
};
export type Action = {
  code: string;
  label: string;
};
export type WidgetHeaderActionProps = {
  actions: Action[];
  elementCode: string;
  itemId: string;
  topLabel: TopLabel;
};

const WidgetHeaderAction: FC<WidgetHeaderActionProps> = ({
  elementCode,
  itemId,
  actions,
  topLabel,
}) => {
  const t = useT();
  const { hasPermission } = usePermissions();
  const { showSuccessToast, showErrorToast } = useToast();
  const { performMutation: createAction, loading } = useCreateActionMutation({
    onSuccess: () => {
      showSuccessToast(t("widget.action.success"));
    },
    onError: () => {
      showErrorToast(t("component.error.text.label"));
    },
  });

  const handleSubmit = async ({ action }: { action: Action }) => {
    if (elementCode && itemId) {
      createAction({
        entityType: "CUSTOMER",
        entityId: itemId,
        elementCode: elementCode,
        actionCode: action.code,
      });
    }
  };

  return (
    <div className="flex items-center">
      <span className="text-xs">{`${topLabel.label}: ${topLabel.value}`}</span>

      {hasPermission(ScopeResource.CUSTOMER, Scope.VIEW) && !loading && actions.length > 0 && (
        <OverflowMenu flipped={true}>
          {actions?.map((action) => (
            <OverflowMenuItem
              key={action.code}
              itemText={<div>{action.label}</div>}
              onClick={() => handleSubmit({ action })}
            />
          ))}
        </OverflowMenu>
      )}
      {loading && <OverlayLoading />}
    </div>
  );
};

export default WidgetHeaderAction;
